import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Button,
  Row,
  Col,
} from "antd";
const { Option } = Select;

function TransformationChildMapping({ setConfig, configdata, sourcePayload }) {
  const [form] = Form.useForm();
  const yesnoOptions = [
    { option: "Yes", value: "1" },
    { option: "No", value: "0" },
  ];
  const operatorOptions = [
    { option: "==", value: "==" },
    { option: "!=", value: "!=" },
  ];
  const conditionTypeOptions = [
    { option: "AND", value: "AND" },
    { option: "OR", value: "OR" },
  ];

  const data_type_mapping = [
    { option: "textbox", value: "str" },
    { option: "number", value: "int" },
    { option: "array", value: "list" },
    { option: "object", value: "dict" },
    { option: "integer", value: "int" },
    { option: "float", value: "float" },    
  ];

  const [conditionType, setConditionType] = useState("OR");
  const [conditions, setConditions] = useState(
    configdata.conditional_child_mapping
      ? configdata.conditional_child_mapping[0].conditions
      : [{ field_name: "", field_value: "", operator: "", condition_type: "" }]
  );
  const [childFields, setChildFields] = useState(
    configdata.conditional_child_mapping
      ? configdata.conditional_child_mapping[0].child_fields
      : [{ field_name: "", value: "", operator: "" }]
  );

  const [config, setconfigdata] = useState({
    ...configdata,
    conditional_child_mapping: [
      {
        conditions: conditions.map(
          ({ field_name, field_value, operator, condition_type }) => ({
            condition_type: condition_type,
            field_name,
            field_value,
            operator,
          })
        ),
        child_fields: childFields.map(({ field_name, value, operator }) => ({
          field_name,
          value,
          operator,
        })),
      },
    ],
  });
  // useEffect(() => {
  //   if (config.conditional_child_mapping) {
  //     setConditions(config.conditional_child_mapping[0].conditions);
  //     setChildFields(config.conditional_child_mapping[0].child_fields);
  //   }
  // }, []);

  const addCondition = () => {
    setConditions([
      ...conditions,
      { field_name: "", field_value: "", operator: "", condition_type: "" },
    ]);
    generateConditionalChildMapping(
      [
        ...conditions,
        { field_name: "", field_value: "", operator: "", condition_type: "" },
      ],
      childFields
    );
  };

  const removeCondition = (index) => {
    const updatedConditions = [...conditions];
    updatedConditions.splice(index, 1);
    setConditions(updatedConditions);
    generateConditionalChildMapping(updatedConditions, childFields);
  };

  const handleConditionChange = (index, field, value) => {
    const updatedConditions = [...conditions];
    updatedConditions[index][field] = value;
    setConditions(updatedConditions);
    generateConditionalChildMapping(updatedConditions, childFields);
  };

  const addChildField = () => {
    setChildFields([
      ...childFields,
      { field_name: "", value: "", operator: "" },
    ]);
    generateConditionalChildMapping(conditions, [
      ...childFields,
      { field_name: "", value: "", operator: "" },
    ]);
  };

  const removeChildField = (index) => {
    const updatedChildFields = [...childFields];
    updatedChildFields.splice(index, 1);
    setChildFields(updatedChildFields);
    generateConditionalChildMapping(conditions, updatedChildFields);
  };

  const handleChildFieldChange = (index, field, value) => {
    const updatedChildFields = [...childFields];
    updatedChildFields[index][field] = value;
    setChildFields(updatedChildFields);
    generateConditionalChildMapping(conditions, updatedChildFields);
  };

  const generateConditionalChildMapping = (conditions, childFields) => {
    const updatedConfig = {
      ...config,
      conditional_child_mapping: [
        {
          conditions: conditions.map(
            ({ field_name, field_value, operator, condition_type }) => ({
              condition_type: condition_type,
              field_name,
              field_value,
              operator,
            })
          ),
          child_fields: childFields.map(({ field_name, value, operator }) => ({
            field_name,
            value,
            operator,
          })),
        },
      ],
    };
    setConfig(updatedConfig);
    console.log(updatedConfig);
  };

  const valueChangeHandler = (e) => {
    console.log(e);
    // console.log(_config.mappingSequence);
    setConfig({ ...config, ...{ child_mapping: e } });
    setconfigdata({ ...config, ...{ child_mapping: e } });
  };
  const handleRemoveMapping = (index) => {
    setConfig({
      ...config,
      conditional_child_mapping: config.conditional_child_mapping.filter(
        (_, i) => i !== index
      ),
    });
    setconfigdata({
      ...config,
      conditional_child_mapping: config.conditional_child_mapping.filter(
        (_, i) => i !== index
      ),
    });
  };

  const handleAddMapping = () => {
    const newMapping = {
      conditions: [
        {
          condition_type: "",
          field_name: "",
          field_value: "",
          operator: "",
        },
      ],
      child_fields: [
        {
          field_name: "",
          value: "",
          operator: "",
        },
      ],
    };

    setConfig({
      ...config,
      conditional_child_mapping: [
        ...config.conditional_child_mapping,
        newMapping,
      ],
    });

    setconfigdata({
      ...config,
      conditional_child_mapping: [
        ...config.conditional_child_mapping,
        newMapping,
      ],
    });
  };
  console.log("conditions", conditions);
  console.log("childFields", childFields);
  console.log("childconfig", config);
  return (
    <>
      <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="Child Mapping"
            name="child_mapping"
            initialValue={config.child_mapping || ""}
          >
            <Select onChange={(e) => valueChangeHandler(e)}>
              <Option value="">Select</Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {console.log("config.conditional_child_mapping", config)}
      {config.child_mapping == "1" &&
        config.conditional_child_mapping.map((child_mapping, childIndex) => (
          <div className="mt-2 mb-2 border p-1 w-auto">
            {child_mapping.conditions.map((condition, index) => (
              <>
                <Row gutter={[24, 16]}>
                  <Col span={7}>
                    <Form.Item
                      key={index}
                      label="Select Field"
                      name={`conditions[${index}].field_name`}
                      initialValue={condition.field_name || ""}
                    >
                      <Select
                        onChange={(e) =>
                          handleConditionChange(index, "field_name", e)
                        }
                      >
                        <Option value="" disabled>
                          Select
                        </Option>
                        {sourcePayload.map((fieldname) => (
                          <Option
                            key={fieldname.payload_field}
                            value={fieldname.payload_field}
                          >
                            {fieldname.payload_field}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      key={index}
                      label="Field Value"
                      name={`conditions[${index}].field_value`}
                      initialValue={condition.field_value || ""}
                    >
                      <Input
                        onChange={(e) =>
                          handleConditionChange(
                            index,
                            "field_value",
                            e.target.value
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      key={index}
                      label="Operator"
                      name={`conditions[${index}].operator`}
                      initialValue={condition.operator || ""}
                    >
                      <Select
                        value={condition.operator}
                        onChange={(e) =>
                          handleConditionChange(index, "operator", e)
                        }
                      >
                        {operatorOptions.map(({ option, value }) => (
                          <Option key={option} value={value}>
                            {option}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      key={index}
                      label="Condition Type"
                      name={`conditions[${index}].condition_type`}
                      initialValue={condition.condition_type || ""}
                    >
                      <Select
                        onChange={(e) =>
                          handleConditionChange(index, "condition_type", e)
                        }
                      >
                        {conditionTypeOptions.map(({ option, value }) => (
                          <Option key={option} value={value}>
                            {option}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    {conditions.length !== 1 && (
                      <button
                        className="btn btn-danger mt-4 mr-1 ml-1"
                        onClick={() => removeCondition(index)}
                      >
                        -
                      </button>
                    )}
                    {conditions.length - 1 === index && (
                      <button
                        className="btn btn-primary mt-4 mr-1 ml-1"
                        onClick={addCondition}
                      >
                        +
                      </button>
                    )}
                  </Col>
                </Row>
              </>
            ))}
            {child_mapping.child_fields.map((childField, i) => (
              <Row gutter={[24, 16]}>
                <Col span={4}>
                  <Form.Item
                    key={i}
                    label="Field Name"
                    name={`childFields[${i}].field_name`}
                    initialValue={childField.field_name || ""}
                  >
                    <Input
                      onChange={(e) =>
                        handleChildFieldChange(i, "field_name", e.target.value)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    key={i}
                    label="Operator"
                    name={`childFields[${i}].operator`}
                    initialValue={childField.operator || ""}
                  >
                    <Select
                      onChange={(e) => handleChildFieldChange(i, "operator", e)}
                    >
                      {data_type_mapping.map(({ option, value }) => (
                        <Option key={option} value={value}>
                          {option}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    key={i}
                    label="Field Value"
                    name={`childFields[${i}].value`}
                    initialValue={childField.value || ""}
                  >
                    <Input
                      //value={childField.value}
                      onChange={(e) =>
                        handleChildFieldChange(i, "value", e.target.value)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  {childFields.length !== 1 && (
                    <button
                      className="btn btn-danger mt-4 mr-1 ml-1"
                      onClick={() => removeChildField(i)}
                    >
                      -
                    </button>
                  )}
                  {childFields.length - 1 === i && (
                    <button
                      className="btn btn-primary mt-4 mr-1 ml-1"
                      onClick={addChildField}
                    >
                      +
                    </button>
                  )}
                </Col>
              </Row>
            ))}
            <div>
              {config.conditional_child_mapping.length !== 1 && (
                <button
                  className="btn btn-danger mb-2 mr-1 ml-1"
                  onClick={() => handleRemoveMapping(childIndex)}
                >
                  Remove Mapping
                </button>
              )}
              {config.conditional_child_mapping.length - 1 === childIndex && (
                <button
                  className="btn btn-primary mb-2 mr-1 ml-1"
                  onClick={handleAddMapping}
                >
                  New Mapping
                </button>
              )}
            </div>
          </div>
        ))}
    </>
  );
}

export default TransformationChildMapping;
